<app-logo-header></app-logo-header>
<section class="section m-5">
  <h3 *ngIf="showPleaseWait" class="container mx-auto">{{ "Buyer.PleaseWait" | translate}}</h3>
  <div *ngIf="!showPleaseWait" class="container">
    <div class="{{ !paymentPaid ? 'fail-card' : 'success-card' }} mx-auto p-3">
      <div class="text-center mb-3">
        <img *ngIf="!paymentPaid" src="../../../../../assets/images/easykash-logo-fail.png" />
        <img *ngIf="paymentPaid" src="../../../../../assets/images/easykash-logo.png" />
      </div>
      <div class="card shadow-lg p-3 mb-3">
        <div class="text-center {{ !paymentPaid ? 'text-danger' : 'text-success'}}">
          <svg *ngIf="!paymentPaid" aria-hidden="true" focusable="false" data-prefix="fad" height="48" width="48"
               data-icon="times-circle" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 208.9 208.9">
            <circle fill="#e1253c" cx="104.4" cy="104.4" r="104.4" />
            <path fill="#8f1d2c" d="M49.7,138.8L84,104.4L49.7,70l20.4-20.4L104.4,84l34.4-34.4L159.2,70l-34.4,34.4l34.4,34.4l-20.4,20.4
              	l-34.4-34.4L70,159.2L49.7,138.8z" />
          </svg>
          <svg *ngIf="paymentPaid" aria-hidden="true" focusable="false" data-prefix="fad" height="48" width="48"
               data-icon="check-circle" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
            <g class="fa-group">
              <path fill="#2eca8b" d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm155.31 195.31l-184 184a16 16 0 0 1-22.62 0l-104-104a16 16 0 0 1 0-22.62l22.62-22.63a16 16 0 0 1 22.63 0L216 308.12l150.06-150.06a16 16 0 0 1 22.63 0l22.62 22.63a16 16 0 0 1 0 22.62z" class="fa-secondary"></path>
              <path fill="#198754" d="M227.31 387.31a16 16 0 0 1-22.62 0l-104-104a16 16 0 0 1 0-22.62l22.62-22.63a16 16 0 0 1 22.63 0L216 308.12l150.06-150.06a16 16 0 0 1 22.63 0l22.62 22.63a16 16 0 0 1 0 22.62l-184 184z"></path>
            </g>
          </svg>
          <h5 class="{{paymentPaid ? 'text-success' : 'text-danger' }} fw-bold">{{ paymentPaid ? 'Success' : 'Failed'}}</h5>
        </div>
        <p *ngIf="paymentPaid">
          {{ "PROVIDER.CREDIT.MESSAGESUCCESS" | translate: { value: gateMessage || "" } }}
        </p>
        <p *ngIf="!paymentPaid">
          {{ "PROVIDER.CREDIT.MESSAGEFAILED" | translate}}
        </p>
        <div *ngIf="reason">
          <p>{{ "PROVIDER.CREDIT.REASON" | translate}}</p>
          <p >{{ '{' }} {{ reason }} {{ '}' }}</p>
          <p>{{ "PROVIDER.CREDIT.CONTACTYOURBANK" | translate }}</p>
        </div>
      </div>
      <div class="d-flex">
        <button (click)="onContinueClick()"
                class="btn {{paymentPaid ? 'btn-success' : 'btn-danger' }} col-12">Continue</button>
      </div>
    </div>
    <app-receipt *ngIf="showRecipt"></app-receipt>
  </div>
</section>
